module.exports = "/_next/static/images/GeneralL-3dbbcbf7bd1199d0e8ab451a29c46b5c.png";